import { render } from "./BrandPortfolioParentRow.vue?vue&type=template&id=cb616dba"
import script from "./BrandPortfolioParentRow.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioParentRow.vue?vue&type=script&lang=js"

import "./BrandPortfolioParentRow.vue?vue&type=style&index=0&id=cb616dba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__